import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import useMembership from '@space-shell/common/hooks/useMembership'
import useRequest from '@space-shell/common/hooks/useRequest'
import { CommunitiesEndpoints, CommunitiesService } from '@space-shell/common/services/communities'

const COMMUNITIES_ROWS = 25

export const useGetGroups = () => {
  const { membershipSlug } = useMembership()
  const { authStatus } = useAuthContext()

  const isUnauthenticated = authStatus === AuthStatus.UNAUTHENTICATED

  const url = isUnauthenticated
    ? CommunitiesEndpoints.getGroupCommunitiesPublic(membershipSlug)
    : CommunitiesEndpoints.getGroupCommunities(membershipSlug)

  const {
    data: groupCommunitiesList,
    isLoading: isLoadingGetGroupCommunities,
    invalidate: invalidateGroupCommunitiesQuery,
    isRefetching: isRefetchingGetGroupCommunities
  } = useRequest([url], () => {
    return isUnauthenticated
      ? CommunitiesService.getGroupCommunitiesPublic(membershipSlug, COMMUNITIES_ROWS)
      : CommunitiesService.getGroupCommunities(membershipSlug, COMMUNITIES_ROWS)
  })

  return {
    groupCommunitiesList,
    isLoadingGetGroupCommunities,
    isRefetchingGetGroupCommunities,
    invalidateGroupCommunitiesQuery
  }
}
